<form [formGroup]="form" (ngSubmit)="submitForm()" class="grid md:grid-cols-2 grid-cols-1 gap-y-1 gap-x-2">
  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>{{ "Jina la Kwanza"|concat|translate }}</mat-label>
    <input matInput formControlName="userFirstName"/>
    <mat-error *ngIf="form.get('userFirstName')?.hasError('required')">
      {{ "Taarifa hii ni ya lazima kujaza"|concat|translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>{{ "Jina la Mwisho"|concat|translate }}</mat-label>
    <input matInput formControlName="userLastName"/>
    <mat-error *ngIf="form.get('userLastName')?.hasError('required')">
      {{ "Taarifa hii ni ya lazima kujaza"|concat|translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>{{ "Jamii Namba"|concat|translate }}</mat-label>
    <input matInput
           formControlName="userNidaNumber"
           mask="00000000-00000-00000-00"
           placeholder="________-_____-_____-__"/>

    <mat-error *ngIf="form.get('userNidaNumber')?.hasError('required')">
      {{ "Taarifa hii ni ya lazima kujaza"|concat|translate }}
    </mat-error>
    <mat-error *ngIf="form.get('userNidaNumber')?.hasError('pattern')">
      {{ "Jamii Namba si sahihi"|concat|translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>{{ "Namba ya Simu"|concat|translate }}</mat-label>
    <input matInput formControlName="profilePhone" mask="000-0000-00000" placeholder="255-___-___-___"/>
    <mat-error *ngIf="form.get('profilePhone')?.hasError('required')">
      {{ "Taarifa hii ni ya lazima kujaza"|concat|translate }}
    </mat-error>
    <mat-error *ngIf="form.get('profilePhone')?.hasError('pattern')">
      {{ "Namba ya simu si sahihi"|concat|translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="md:col-span-2 col-span-1 w-full" appearance="outline">
    <mat-label>{{ "Barua Pepe"|concat|translate }}</mat-label>
    <input matInput formControlName="userEmail"/>
    <mat-error *ngIf="form.get('userEmail')?.hasError('email')">
      {{ "Barua Pepe si sahihi"|concat|translate }}
    </mat-error>
    <mat-error *ngIf="form.get('userEmail')?.hasError('required')">
      {{ "Taarifa hii ni ya lazima kujaza"|concat|translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>{{ "Nywila"|concat|translate }}</mat-label>
    <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="userPassword"/>
    <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" tabindex="-1">
      <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
    <mat-error *ngIf="form.get('userPassword').hasError('passwordPolicy')">
      {{ "Nywila lazima iwe na angalau herufi 8, ikiwa na herufi kubwa na ndogo, nambari, na alama maalum"|concat|translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="col-span-1 w-full" appearance="outline">
    <mat-label>{{ "Hakiki Nywila"|concat|translate }}</mat-label>
    <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword"/>
    <button mat-icon-button matSuffix type="button" (click)="hideConfirmPassword = !hideConfirmPassword" tabindex="-1">
      <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
    <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')">
      {{ "Taarifa hii ni ya lazima kujaza"|concat|translate }}
    </mat-error>
    <mat-error *ngIf="form.get('confirmPassword')?.hasError('passwordMismatch')">
      {{ "Nywila na hakiki hazifanani"|concat|translate }}
    </mat-error>
  </mat-form-field>

  <div class="md:col-span-2 col-span-1">
    <mat-checkbox formControlName="consent">
      <div class="flex flex-col">
        <p class="font-bold border-b pb-1">{{ "Consent"|concat|translate }}</p>
        <span [innerHTML]="seraYaFaraghaText"></span>
      </div>
    </mat-checkbox>
    <mat-error *ngIf="form.get('consent')?.hasError('required')">
      <span class="mt-3"> {{ "Lazima ukubaliane na "|concat|translate }} <a class="underline text-primary-600"
                                                                            href="/privacy-policy"
                                                                            target="_blank">{{ "Sera ya Faragha"|concat|translate }}</a></span>
    </mat-error>
  </div>

  <div class="md:col-span-2 col-span-1 mt-1">
    <button mat-raised-button color="primary" class="w-full py-3" type="submit" [disabled]="form.invalid">
      {{ "Save"|concat|translate }}
    </button>
  </div>
</form>
